import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { PropTypes as MobXPropTypes, inject, observer } from 'mobx-react'
import { autobind } from 'core-decorators'
import { observable } from 'mobx'
import ListEntry from './ListEntry'
import TabNav from '../../shared/components/TabNav'

@inject('rating', 'auth')
@observer
export default class List extends Component {

  static propTypes = {
    auth: MobXPropTypes.observableObject,
    rating: PropTypes.object,
  }

  constructor(props) {
    super(props)
    this.state = {
      activeRatingId: null
    }
  }

  @observable activeTab = 'own'

  @autobind
  handleActiveChange({ target }) {
    this.setState({
      activeRatingId: target.id === this.state.activeRatingId
        ? null
        : target.id
    })
  }

  @autobind
  handleTabChanged(e) {
    this.activeTab = e.target.value
  }

  render() {

    const { rating, auth } = this.props
    const user = auth.user
    const isAdmin = auth.acs.isAuthorized('Admin')
    const tabs = [{ title: 'Eigene', value: 'own' }, { title: 'Alle', value: 'all' }]

    return (
      <div className="vertical">
        <div
          className="vertical"
        >
          <h1>
            Bewertungen
          </h1>
          {auth.acs.isAuthorized('Admin') ? null
            : (
              <TabNav
                tabs={tabs}
                active={this.activeTab}
                onTabChanged={this.handleTabChanged}
              />
            )}
          <ol className="nav-list rating-list">
            {rating.loading ? ('Bewertungen werden geladen...')
              : rating.collection
                .filter((currRating) => {
                  if (isAdmin || this.activeTab === 'all') {
                    return true
                  }
                  return currRating.museum.id === user.museumId || currRating.museum.versionRefId === user.museumId
                })
                .map((currRating) => (
                  <ListEntry
                    key={currRating.id}
                    rating={currRating}
                    isActive={currRating.id === this.state.activeRatingId}
                    onClick={this.handleActiveChange}
                  />
                ))}
          </ol>
        </div>
      </div>
    )
  }

}



// WEBPACK FOOTER //
// ./src/rating/components/List.js